export const useStudentAssignmentDataStore = (assignmentId: string) => {
  return useStudentAssignmentData(assignmentId)();
};
